<template>
  <v-dialog v-model="deleteDialog" width="500">
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-if="!isIcon"  v-on="on" v-bind="attrs" color="red" depressed class="white--text" >{{ $t(`${name}`) }}</v-btn>
      <v-btn icon v-if="isIcon && !iconProps"><v-icon  v-on="on" v-bind="attrs" color="red">mdi-delete</v-icon> </v-btn>
      <v-btn icon v-if="isIcon && iconProps" ><v-icon  v-on="on" v-bind="attrs" color="red">{{iconProps}}</v-icon></v-btn>
    </template>
    <v-card style="transform: none !important;">
      <v-card-title class="d-flex justify-center card-title__heading">
        <h2> {{ $t('are you sure you want delete') }} </h2>
      </v-card-title>
      <v-card-actions class="justify-center">
        <v-btn color="green" class="white--text" depressed @click="deleteRecord" :loading="deleteBtnLoading"> {{ $t('delete') }} </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
  
<script>
  import axios from "axios";
  import Notifications from "../../../../helpers/toast-notifications";
  export default {
    data() {
      return {
        deleteBtnLoading: false,
        deleteDialog: false,
      };
    },
    props: {
      id: [String, Number],
      path: String,
      iconProps: String,
      name: String,
      isIcon: {
        type: Boolean,
        default: true,
      },
      params: {
        type: Object,
        default: () => { return {};},
      },
    },
    methods: {
      async deleteRecord() {
        try {
          this.deleteBtnLoading = true;
          if(this.path=='final-grade-student' || this.path=='igcse-student'){
            if(this.isIcon) {
              this.params = {id: this.id};
            }
            await axios.post(`/${this.path}/delete`, this.params);
          } 
          else if(this.path=='/hr/employee/contract/rule') {
                await axios.delete(`${this.path}`, {params: {...this.params}});
         }
          else {
            await axios.delete(`/${this.path}/${this.id}`);
          }

          this.$emit("record-deleted");
          this.deleteDialog = false;
          Notifications(
            this.$t('delete success'),
            { timeout: 2000, rtl: true },
            "success"
          );
        } catch (err) {
        } finally {
          this.deleteBtnLoading = false;
        }
      },
    },
  };
  </script>
  
  <style></style>
  